import apiClient from "../helpers/apiClient";

export const getLoyaltyProgramsActivities = async () => {
    const response = await apiClient.get('/loyalty_program/activities/');
    return response?.data?.results ?? [];
};

export const getMyPayments = async (params:any) => {
    const response = await apiClient.get('/loyalty-program/member/payments/',{params: params});
    return response?.data;
};

export const getMyCredits = async (params:any) => {
    const response = await apiClient.get('/loyalty-program/member/transactions/',{params: params});
    return response?.data;
};